import PageTitle from "../ui/PageTitle";
import { Form, useActionData } from "react-router-dom";
import { Button, Stack, styled, TextField } from "@mui/material";
import FormHeader from "../ui/FormHeader";
import { useEffect, useRef, useState } from "react";
import useInfoSnackbar from "../../lib/bandung/hooks/useInfoSnackbar";

const StyledStack = styled(Stack)`
  height: 100%;
  width: 100%;
  padding-top: 3em;
`;

const CHARACTER_LIMIT_SHORT = 500;
const CHARACTER_LIMIT_LONG = 1500;

const Create = () => {
  const snackbarInfo = useInfoSnackbar(2000, "bottom", "right");
  const formRef = useRef();

  const [formData, setFormData] = useState({
    shortDescription: "",
    longDescription: "",
  });

  const actionData = useActionData();
  const handleChange = (name) => (event) => {
    const { value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        snackbarInfo.alertSuccess(actionData.message);
        formRef.current.reset();
        setFormData({
          shortDescription: "",
          longDescription: "",
        });
      } else {
        snackbarInfo.alertError(actionData.message);
      }
    }
  }, [actionData]);

  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Create Conversations"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Conversations", path: "/conversation" },
              { name: "Create", path: "/conversation/create" },
            ]}
          />
        </div>

        <div className="flex items-center justify-center">
          <div className="w-[600px] bg-white p-10 border-solid border-2 mt-8">
            <FormHeader title="Create a Conversation" />
            <StyledStack>
              <Form method="post" ref={formRef}>
                <Stack
                  direction={"column"}
                  justifyContent={"space-between"}
                  spacing={2}
                  mb={2}
                >
                  <TextField
                    type="text"
                    id="label"
                    name="label"
                    label={"Label"}
                    fullWidth
                    required={true}
                  />
                  <TextField
                    type="text"
                    id="name"
                    name="name"
                    label={"Name"}
                    fullWidth
                    required={true}
                  />
                  <TextField
                    type="text"
                    id="order"
                    name="order"
                    label={"Order"}
                    fullWidth
                    required={true}
                  />
                  <TextField
                    type="text"
                    id="shortDescription"
                    name="shortDescription"
                    label={"Short Description"}
                    fullWidth
                    multiline
                    rows={2}
                    inputProps={{
                      maxLength: CHARACTER_LIMIT_SHORT,
                    }}
                    value={formData.shortDescription}
                    helperText={`${formData.shortDescription.length}/${CHARACTER_LIMIT_SHORT}`}
                    onChange={handleChange("shortDescription")}
                  />
                  <TextField
                    type="text"
                    id="longDescription"
                    name="longDescription"
                    label={"Long Description"}
                    fullWidth
                    multiline
                    rows={4}
                    inputProps={{
                      maxLength: CHARACTER_LIMIT_LONG,
                    }}
                    value={formData.longDescription}
                    helperText={`${formData.longDescription.length}/${CHARACTER_LIMIT_LONG}`}
                    onChange={handleChange("longDescription")}
                  />
                </Stack>
                <Stack mt={2}>
                  <Button
                    type={"submit"}
                    variant={"outlined"}
                    sx={{
                      color: "#1e3faf",
                      borderRadius: "9999px",
                      borderColor: "#60a5fa",
                      "&:hover": {
                        backgroundColor: "#dbeafe",
                      },
                    }}
                  >
                    Create
                  </Button>
                </Stack>
              </Form>
            </StyledStack>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create;
